export const getConversionTypesConfig = ({ typeOfSelectedObj, selectedId }) => ({
    url: `/api/${typeOfSelectedObj}/${selectedId}/facebook/conversion-types/`,
    method: 'GET',
});
